/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechGetTranscriptionHistoryContent } from "../../funcs/llmSpeechGetTranscriptionHistoryContent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetSpeechToTextHistoryContentRequest$inboundSchema,
};

export const tool$llmSpeechGetTranscriptionHistoryContent: ToolDefinition<
  typeof args
> = {
  name: "llm-speech-get-transcription-history-content",
  description: `Retrieve speech-to-text audio

Returns the stored input audio for a transcription as a binary response.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechGetTranscriptionHistoryContent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
